import { createContext, useContext } from 'react'

export const OrgContext = createContext<{ orgId: number; orgName: string } | null>(null)

export function useOrg() {
  const ctx = useContext(OrgContext)
  if (!ctx) throw new Error('useOrg doit être utilisé dans OrgLayout')
  return ctx
}
